{
  "id": "barracks",
  "role": "barracks",
  "width": 3,
  "height": 3,
  "dropOff": [],
  "supplyProvided": 0,
  "trains": ["melee", "ranged"],
  "cost": {
    "gold": 100,
    "lumber": 50
  },
  "buildTicks": 300,
  "hp": 800
}
